import { SRS_CUSTOMER_VALIDATE_API } from 'constants/AppConstants';

export default async (isBillingAffiliate, eagleViewCustomerId, srsCustomerCode, srsShipToNumber) => {
  try {
    const response = await fetch(`${SRS_CUSTOMER_VALIDATE_API}?billingAffiliate=${isBillingAffiliate}`, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ eagleViewCustomerId, srsCustomerCode, srsShipToNumber }),
    });
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
